export default __webpack_public_path__ + "static/media/google_meet_icon.5829d014.svg";